var _circle, _circle2, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelete2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#C8131B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 26.0035,
    r: 17.6129,
    fill: "#C8131B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15804_22003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9354,
    y: 15.9375,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15804_22003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7688 33.4375C21.3105 33.4375 20.9181 33.2743 20.5917 32.9479C20.2653 32.6215 20.1021 32.2292 20.1021 31.7708V20.9375C19.866 20.9375 19.6681 20.8576 19.5084 20.6979C19.3487 20.5382 19.2688 20.3403 19.2688 20.1042C19.2688 19.8681 19.3487 19.6701 19.5084 19.5104C19.6681 19.3507 19.866 19.2708 20.1021 19.2708H23.4355C23.4355 19.0347 23.5153 18.8368 23.675 18.6771C23.8348 18.5174 24.0327 18.4375 24.2688 18.4375H27.6021C27.8382 18.4375 28.0362 18.5174 28.1959 18.6771C28.3556 18.8368 28.4355 19.0347 28.4355 19.2708H31.7688C32.0049 19.2708 32.2028 19.3507 32.3625 19.5104C32.5223 19.6701 32.6021 19.8681 32.6021 20.1042C32.6021 20.3403 32.5223 20.5382 32.3625 20.6979C32.2028 20.8576 32.0049 20.9375 31.7688 20.9375V31.7708C31.7688 32.2292 31.6056 32.6215 31.2792 32.9479C30.9528 33.2743 30.5605 33.4375 30.1021 33.4375H21.7688ZM24.2688 30.1042C24.5049 30.1042 24.7028 30.0243 24.8625 29.8646C25.0223 29.7049 25.1021 29.5069 25.1021 29.2708V23.4375C25.1021 23.2014 25.0223 23.0035 24.8625 22.8438C24.7028 22.684 24.5049 22.6042 24.2688 22.6042C24.0327 22.6042 23.8348 22.684 23.675 22.8438C23.5153 23.0035 23.4355 23.2014 23.4355 23.4375V29.2708C23.4355 29.5069 23.5153 29.7049 23.675 29.8646C23.8348 30.0243 24.0327 30.1042 24.2688 30.1042ZM27.6021 30.1042C27.8382 30.1042 28.0362 30.0243 28.1959 29.8646C28.3556 29.7049 28.4355 29.5069 28.4355 29.2708V23.4375C28.4355 23.2014 28.3556 23.0035 28.1959 22.8438C28.0362 22.684 27.8382 22.6042 27.6021 22.6042C27.366 22.6042 27.1681 22.684 27.0084 22.8438C26.8487 23.0035 26.7688 23.2014 26.7688 23.4375V29.2708C26.7688 29.5069 26.8487 29.7049 27.0084 29.8646C27.1681 30.0243 27.366 30.1042 27.6021 30.1042Z",
    fill: "#C8131B"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete2.a53e65f1.svg";
export { ForwardRef as ReactComponent };